<template>
  <div class="faq_area">
    <p class="txt_faq">
      <span>Q<em>{{ order }}</em></span>
      {{ text }}
    </p>
    <ul class="answer_area">
      <li @click="set('A+')"><span>あてはまる</span></li>
      <li @click="set('A')"><span>どちらかと<br>いうと<br>あてはまる</span></li>
      <li @click="set('B')"><span>どちらかと<br>いうと<br class="view_pc">あて<br class="view_sp">はまらない</span></li>
      <li @click="set('B+')"><span>あて<br class="view_sp">はまらない</span></li>
    </ul>
  </div>
</template>

<script setup>
import { inject, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

/* data */
const order = ref()
const text = ref()

const questionsStore = inject('questionsStore')

const emit = defineEmits(['handleClick'])
const set = (answer) => {
  emit('handleClick', answer, order.value)
}

onMounted(async () => {
  await router.isReady()

  order.value = route.meta.order
  text.value = questionsStore.tendencies(route.meta.textIndex)
})
</script>
